export { wait as default } from 'function-tree/factories'
